var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.33333L19.026 7.21333L22.638 10.6667H8.4V13.3333H22.638L19.026 16.7733L21 18.6667L28 12L21 5.33333ZM2.8 2.66667H14V0H2.8C1.26 0 0 1.2 0 2.66667V21.3333C0 22.8 1.26 24 2.8 24H14V21.3333H2.8V2.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.33333L19.026 7.21333L22.638 10.6667H8.4V13.3333H22.638L19.026 16.7733L21 18.6667L28 12L21 5.33333ZM2.8 2.66667H14V0H2.8C1.26 0 0 1.2 0 2.66667V21.3333C0 22.8 1.26 24 2.8 24H14V21.3333H2.8V2.66667Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.10600a903862606af0aac1502c6a273e.svg";
export { ForwardRef as ReactComponent };